import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { formAssetsValidator } from '../../../subcomponents/form/form/types/assets';
import { memberFormDisplayTextValidator } from '../../../subcomponents/member-form/types/display-text';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultUpdateMemberDetailsFormConfig, updateMemberDetailsFormConfigValidator } from './config';
import { defaultUpdateMemberDetailsFormDisplayText } from './display-text';
import { updateMemberDetailsFormEventsValidator } from './events';
export const updateMemberDetailsFormPropsValidator = Validator.object({
    formId: Validator.optional(nonEmptyStringValidator),
    assets: formAssetsValidator,
    displayText: memberFormDisplayTextValidator,
    config: updateMemberDetailsFormConfigValidator,
    events: updateMemberDetailsFormEventsValidator,
    children: reactChildrenValidator
});
export const defaultUpdateMemberDetailsFormProps = {
    assets: {},
    displayText: defaultUpdateMemberDetailsFormDisplayText,
    config: defaultUpdateMemberDetailsFormConfig,
    events: {},
    children: undefined
};
